import en from './en.json';
import de from './de.json';
import es_419 from './es_419.json';
import sv from './sv.json';

export default { en, de, es_419, sv };